module.exports = __webpack_public_path__ + "static/img/cabinet24_24.0e0ce6c7.gif";